var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story"},[_c('div',{staticClass:"banner"},[_c('Carousel',{attrs:{"slides":_vm.banners}})],1),_c('Stories',{attrs:{"stories":_vm.stories}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }